import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormMunicipality } from 'system/geographic/pages/municipality/list/types';
import PmiTextField from 'shell/components/shared/text-field';
import { listNameOperator } from 'shell/constants/select-choice-operator';
import SelectLogicOperation from 'shell/components/shared/select-choice';

interface FiltersMunicipalityProps {
  filterMunicipalityForm: FormikProps<FiltersFormMunicipality>;
}

const FiltersMunicipality = ({
  filterMunicipalityForm,
}: FiltersMunicipalityProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-state-content"
        id="panel-state-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterMunicipalityForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Codice ISTAT"
                label="Codice ISTAT"
                id="istatCode"
                name="istatCode"
                fullWidth
                onBlur={filterMunicipalityForm.handleBlur}
                type="text"
                variant="outlined"
                value={filterMunicipalityForm.values.istatCode}
                onChange={(event) =>
                  filterMunicipalityForm.setFieldValue(
                    'istatCode',
                    event.target.validity.valid
                      ? event.target.value
                      : filterMunicipalityForm.values.istatCode
                  )
                }
                inputProps={{
                  maxLength: '6',
                }}
                error={
                  filterMunicipalityForm.touched.istatCode &&
                  Boolean(filterMunicipalityForm.errors.istatCode)
                }
                helperText={filterMunicipalityForm.errors.istatCode}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Codice comune"
                label="Codice comune"
                id="code"
                name="code"
                fullWidth
                onBlur={filterMunicipalityForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '6',
                }}
                value={filterMunicipalityForm.values.code}
                onChange={(event) =>
                  filterMunicipalityForm.setFieldValue(
                    'code',
                    event.target.validity.valid
                      ? event.target.value
                      : filterMunicipalityForm.values.code
                  )
                }
                error={
                  filterMunicipalityForm.touched.code && Boolean(filterMunicipalityForm.errors.code)
                }
                helperText={filterMunicipalityForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Nome comune"
                label="Nome comune"
                id="name"
                name="name"
                fullWidth
                onBlur={filterMunicipalityForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '40',
                }}
                value={filterMunicipalityForm.values.name}
                onChange={(event) => {
                  filterMunicipalityForm.setFieldValue('name', event.target.value);
                }}
                error={
                  filterMunicipalityForm.touched.name && Boolean(filterMunicipalityForm.errors.name)
                }
                helperText={filterMunicipalityForm.errors.name}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <SelectLogicOperation
                id="name-operation"
                list={listNameOperator}
                onChange={(event) => {
                  filterMunicipalityForm.setFieldValue('nameOperation', event.target.value);
                }}
                value={filterMunicipalityForm.values.nameOperation || ''}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Codice provincia o nazione"
                label="Codice provincia/nazione"
                id="provinceCode"
                name="provinceCode"
                fullWidth
                onBlur={filterMunicipalityForm.handleBlur}
                type="text"
                inputProps={{
                  maxLength: 3,
                }}
                variant="outlined"
                value={filterMunicipalityForm.values.provinceCode}
                onChange={(event) => {
                  filterMunicipalityForm.setFieldValue('provinceCode', event.target.value);
                }}
                error={
                  filterMunicipalityForm.touched.provinceCode &&
                  Boolean(filterMunicipalityForm.errors.provinceCode)
                }
                helperText={filterMunicipalityForm.errors.provinceCode}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiTextField
                aria-label="Codice fiscale"
                label="Codice fiscale"
                id="fiscalCode"
                name="fiscalCode"
                fullWidth
                onBlur={filterMunicipalityForm.handleBlur}
                inputProps={{
                  maxLength: '4',
                }}
                type="text"
                variant="outlined"
                value={filterMunicipalityForm.values.fiscalCode}
                onChange={(event) => {
                  filterMunicipalityForm.setFieldValue('fiscalCode', event.target.value);
                }}
                error={
                  filterMunicipalityForm.touched.fiscalCode &&
                  Boolean(filterMunicipalityForm.errors.fiscalCode)
                }
                helperText={filterMunicipalityForm.errors.fiscalCode}
              />
            </Grid>
            <Grid item xs={2}>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterMunicipalityForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersMunicipality.displayName = 'Filters Municipality component';

export default FiltersMunicipality;
